import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Authority } from '../../gateway/system/Authority'
import { useAppSelector } from '../../stores'

export function useAccessibleAuthority(...accessibleAuthorities: Authority[]): void {
  const userProp = useAppSelector(x => x.common.userProp)
  const navigate = useNavigate()

  React.useEffect(() => {
    if (!accessibleAuthorities.includes(userProp?.authority ?? Authority.None)) {
      navigate('/authority-error', {
        replace: true
      })
    }
  }, [])
}
